import React from "react";
import { useTranslation } from "react-i18next";
import Button from "@/components/Common/Buttons/Button";

interface GoalActionsProps {
  isUserEnrolled?: boolean;
  isSubmitting: boolean;
  onNext: () => void;
  onPrevious: () => void;
}

const GoalActions: React.FC<GoalActionsProps> = ({
  isUserEnrolled,
  isSubmitting,
  onNext,
  onPrevious,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={`flex items-center space-x-4 lg:space-x-0 bg-white ${
        isUserEnrolled
          ? "gap-4"
          : "justify-between mt-[24px] md:shadow-md rounded-[16px] px-0 py-[32px] md:p-[32px]"
      }`}
    >
      <div className={`${isUserEnrolled ? "w-full" : "w-[218px]"}`}>
        <Button
          ariaLabel="previous"
          variant="secondary"
          label={t("common.buttons.previous")}
          iconAlignment="left"
          handleClick={onPrevious}
        />
      </div>
      {!isUserEnrolled && (
        <div className="hidden lg:block flex-1 text-center">
          <p className="leading-[127%] font-normal text-[14px] text-[#C6C6C6]">
            {t("common.progress.step_counter", { current: 2, total: 4 })}
          </p>
        </div>
      )}
      <div className={`${isUserEnrolled ? "w-full" : "w-[218px]"}`}>
        <Button
          iconVisibility="show"
          ariaLabel="next"
          label={t("common.buttons.next")}
          loading={isSubmitting}
          handleClick={onNext}
        />
      </div>
    </div>
  );
};

export default GoalActions;
